<div *ngIf="isMobile; else webLogin" class="full-container">
  <div class="notification-container-mobile">
    <div class="top-content">
        <div class="instruction-mobile">
          {{ data.title }}
        </div>
    </div>

    <div class="middle-content">
      {{ data.message }}
    </div>

    <div class="bottom-content">
        <div class="cancel-button-mobile">
          <button type="button" (click)="onCancel()">OK</button>
        </div>
    </div>
  </div>
</div>


<ng-template #webLogin>
  <div class="notification-container">
    <div class="form-container">
      <div class="form-header">{{ data.title }}</div>
      <div class="table-container">{{ data.message }}</div>
      <div class="form-actions">
        <button type="button" (click)="onCancel()">OK</button>
      </div>
    </div>
  </div>  
</ng-template>
